// PROD endpoints
export const GOLF_PORTAL_AUTH_API_DEV =
  "https://login.trackmangolf.com/connect/token";
export const GOLF_PORTAL_AUTH_API =
  "https://login.trackmangolf.com/connect/token";
export const GOLF_PORTAL_API_DEV = "https://api.trackmanrange.com/graphql";
export const GOLF_PORTAL_API = "https://api.trackmanrange.com/graphql";
export const FACILITY_ID_LIVE =
  "RmFjaWxpdHkKZDk3MTFmNjlhLWQ4OGUtNDJlNi1hYmIyLTgzOTBjYWFiN2VmNg==";
export const FACILITY_ID_DEV =
  "RmFjaWxpdHkKZDk3MTFmNjlhLWQ4OGUtNDJlNi1hYmIyLTgzOTBjYWFiN2VmNg==";

/** NEXT Tour Australia — a second facility fetched alongside the default one (season 5). */
export const FACILITY_ID_NEXT_TOUR_AUSTRALIA =
  "RmFjaWxpdHkKZDAxOWZhMzZkLTlkZmUtNzMxMi05MjUyLTgxNWMxMzY5MTU3OQ==";

/** NEXT Tour Canada — a third facility fetched alongside the default one (season 5). */
export const FACILITY_ID_NEXT_TOUR_CANADA =
  "RmFjaWxpdHkKZDAxYTBlN2JlLWVkNjAtNzYwNC04OWJhLTA5MGVhZjBiOGFmOQ==";

// DEV endpoints
// export const GOLF_PORTAL_AUTH_API =
//   "https://tm-login-dev.trackmangolfdev.com/connect/token";
// export const GOLF_PORTAL_API =
//   "https://dr-cloud-api-dev.trackmangolfdev.com/graphql/";
// export const GOLF_PORTAL_API_DEV =
//   "https://dr-cloud-api-dev.trackmangolfdev.com/graphql/";
// export const GOLF_PORTAL_AUTH_API_DEV =
//   "https://tm-login-dev.trackmangolfdev.com/connect/token";
// export const FACILITY_ID_LIVE =
//   "RmFjaWxpdHkKZDA5ODgxNmEyLTQxZmUtNDcwOC1hZmRiLTQ0ZjFkNWFiMjUyYQ==";
// export const FACILITY_ID_DEV =
//   "RmFjaWxpdHkKZDA5ODgxNmEyLTQxZmUtNDcwOC1hZmRiLTQ0ZjFkNWFiMjUyYQ==";

// AM TEST TOURNAMENT FACILITY
// export const FACILITY_ID_LIVE =
//   "RmFjaWxpdHkKZDVlYWE0MDM1LTM3MjQtNDYxNS1hZDc1LTIzY2Y2ZmQ1NWM1Zg==";
// export const FACILITY_ID_DEV =
//   "RmFjaWxpdHkKZDVlYWE0MDM1LTM3MjQtNDYxNS1hZDc1LTIzY2Y2ZmQ1NWM1Zg==";

// Marketing test facility
// export const FACILITY_ID_LIVE =
//   "RmFjaWxpdHkKZDBkYWIyMTRmLWFjMzYtNDYzNy1iMGE5LTY1OGUzYzhhNDNlYQ==";
// export const FACILITY_ID_DEV =
//   "RmFjaWxpdHkKZDBkYWIyMTRmLWFjMzYtNDYzNy1iMGE5LTY1OGUzYzhhNDNlYQ==";

// STAGE endpoints
// export const GOLF_PORTAL_API_DEV =
//   "https://tm-cloud-api-staging.azurewebsites.net/graphql";
// export const GOLF_PORTAL_API =
//   "https://tm-cloud-api-staging.azurewebsites.net/graphql";

//Season 1 and 2
export const ENTRY_FEE = 100;
export const ENTRY_FEE_WITH_TAX = 130;
export const INITIAL_PURSE = 100000;
export const INITIAL_PURSE_ELEVATED = 150000;
export const FIRST_PLACE_PRICE = 30000;
export const FIRST_PLACE_PRICE_ELEVATED = 50000;
export const AGGREGATE_CTP_LAST = ["6,000", "4,000", "2,000"];
export const AGGREGATE_CTP_FINALE = ["2,500", "1,500", "1,000"];
export const AGGREGATE_CTP = ["4,000", "2,500", "1,500"];
export const AGGREGATE_CTP_4_5_6_ROUNDS = ["3,000", "1,500", "1,000"];
export const BIRDIE_STREAK_LAST = ["1,500", "850", "400"];
export const BIRDIE_STREAK_4_5_6_ROUNDS = ["1,000", "500"];
export const BIRDIE_STREAK = ["1,500", "1,000", "500"];
export const LONGEST_DRIVE = ["2,500", "1,500", "1,000"];
export const LONGEST_DRIVE_LAST = ["2,000", "1,250", "500"];
export const LONGEST_DRIVE_4_5_6_ROUNDS = ["2,000", "1,000", "500"];
export const MOST_GIRS = ["1,500", "1,000", "500"];
export const MOST_GIRS_LAST = ["1,500", "850", "400"];
export const SOCIAL_MEDIA = ["2,000", "1,000"];
export const SOCIAL_MEDIA_LAST = "2,000";
export const SOCIAL_MEDIA_FINALE = [
  "1,000",
  "1,000",
  "1,000",
  "1,000",
  "1,000",
];
export const PRIZES_FINAL_SEASON_2 = [
  30000, 20000, 15000, 10000, 7500, 5000, 3000, 2000, 1500, 1000,
];

//Season 3
export const ENTRY_FEE_PGA = 50;
export const INITIAL_PURSE_PGA = 25000;
export const CTP_PGA_SEASON_3 = ["1,000", "500", "300", "200", "100"];

export const INITIAL_PURSE_SEASON_3_FINAL = 150000;
export const AGGREGATE_CTP_SEASON_3 = ["1,500", "1,000", "500"];
export const LONGEST_DRIVE_SEASON_3 = ["1,500", "750", "250"];
export const LONGEST_DRIVE_SEASON_3_FINAL = ["1,000", "500"];
export const SOCIAL_MEDIA_SEASON_3 = ["2,000", "2,000", "1,000"];
export const CTP_SEASON_3 = ["1,000", "500", "250"];
export const PRIZES_FINAL_SEASON_3 = [
  30000, 25000, 20000, 15000, 11000, 9000, 7000, 5000, 4000, 3000, 2000, 1500,
  1000, 800, 700, 600, 500, 400, 300, 200,
];

//Season 4
export const INITIAL_PURSE_NEXT_WORLD_SERIES = 150000;
export const INITIAL_PURSE_NEXT_CHAMPIONSHIP = 250000;
export const ENTRY_FEE_NEXT_SERIES = 0;
export const CTP_PGA_SEASON_4 = ["750", "500", "300", "200"];
export const LONGEST_DRIVE_PGA_SEASON_4 = ["750"];
export const INITIAL_PURSE_PGA_AUSTRALIA = 7500;
export const CTP_PGA_AUSTRALIA_SEASON_4 = ["400", "300", "200"];
export const LONGEST_DRIVE_PGA_AUSTRALIA_SEASON_4 = ["300"];
export const ENTRY_FEE_PGA_AUSTRALIA_SEASON_4 = 75;
export const ENTRY_FEE_PGA_CANADA_SEASON_4 = 100;
export const AGGREGATE_CTP_S4 = ["1,500", "500"];
export const SOCIAL_MEDIA_S4 = ["1,500", "1,500"];
export const LONGEST_DRIVE_MEN_S4 = ["1,500", "1,000", "500"];
export const LONGEST_DRIVE_WOMEN_S4 = ["1,500", "1,000", "500"];
export const CTP_S4 = ["1,000", "750", "500"];
export const CTP_WORLD_SERIES_STAGE_2_3_S4 = ["1,250", "1,000", "750"];
export const ENTRY_FEE_EPSON = 50;
export const INITIAL_PURSE_EPSON = 40000;
export const CTP_EPSON = ["1,000", "500", "250"];
export const LONGEST_DRIVE_EPSON = ["1,000", "500"];
export const SOCIAL_MEDIA_EPSON = ["1,500"];
export const CTP_CHAMPIONSHIP_S4 = ["2,000", "1,000", "750"];
export const LONGEST_DRIVE_WOMEN_CHAMPIONSHIP_S4 = ["1,500", "1,000", "750"];

// Season 5 — TODO(season 5): these mirror season 4 as placeholders.
// Confirm each before S5 goes live; editing them must not affect season 4.
export const INITIAL_PURSE_S5 = 100000;
export const ENTRY_FEE_S5 = 100;
export const ENTRY_FEE_WITH_TAX_S5 = 130;
// Challengers S5.
export const INITIAL_PURSE_CHALLENGERS_S5 = 15000;
export const ENTRY_FEE_CHALLENGERS_S5 = 65;
export const FIRST_PLACE_PRIZE_CHALLENGERS_S5 = 7500;
export const PAID_PLACES_CHALLENGERS_S5 = 40;
export const PRIZE_SCALING_CHALLENGERS_S5 = 0.22;
export const MIN_PRIZE_CHALLENGERS_S5 = 50;
export const CTP_CHALLENGERS_S5 = [400, 300, 200];
export const LONGEST_DRIVE_CHALLENGERS_S5 = [300];
export const SIDE_GAMES_CHALLENGERS_S5 =
  4 * CTP_CHALLENGERS_S5.reduce((sum, prize) => sum + prize, 0) +
  2 * LONGEST_DRIVE_CHALLENGERS_S5[0];
// Open Qualifier S5: reserve the winner and side games separately.
export const FIRST_PLACE_PRIZE_OPEN_QUALIFIER_S5 = 30000;
export const SIDE_GAMES_OPEN_QUALIFIER_S5 = 17000;
export const PRIZE_RATIO_OPEN_QUALIFIER_S5 = 1.3;
export const PRIZE_TIERS_OPEN_QUALIFIER_S5 = [
  { percentile: 0.05, prize: 350 },
  { percentile: 0.1, prize: 300 },
  { percentile: 0.15, prize: 250 },
  { percentile: 0.2, prize: 200 },
  { percentile: 0.25, prize: 150 },
  { percentile: 0.3, prize: 100 },
];
export const INITIAL_PURSE_NEXT_WORLD_SERIES_S5 = 150000;
// World Series S5: identical rules for Stage 1 and Stage 2.
export const FIRST_PLACE_PRIZE_WORLD_SERIES_S5 = 30000;
export const SIDE_GAMES_WORLD_SERIES_S5 = 20000;
export const PAID_PLAYERS_PCT_WORLD_SERIES_S5 = 0.3;
export const PRIZE_SCALING_WORLD_SERIES_S5 = 0.3;
export const MIN_PRIZE_WORLD_SERIES_S5 = 100;
export const INITIAL_PURSE_NEXT_CHAMPIONSHIP_S5 = 250000;
export const SIDE_BETS_PCT_CHAMPIONSHIP_S5 = 0.1;
export const ENTRY_FEE_NEXT_SERIES_S5 = 0;
export const INITIAL_PURSE_PGA_S5 = 25000;
export const ENTRY_FEE_PGA_S5 = 50;
export const FIRST_PLACE_PRIZE_PGA_S5 = 10000;
export const SIDE_GAMES_PGA_S5 = 8500;
export const MIN_PRIZE_PGA_S5 = 50;
export const PRIZE_SCALING_PGA_S5 = 0.25;
export const PAID_PLACES_PCT_PGA_S5 = 0.1;
// ECB reference rate on 2026 (1 AUD in USD); used only for the season summary purse total.
export const AUD_TO_USD_RATE = 0.69849;
// ECB reference rate of 30 Oct 2026 (1 CAD in USD = EUR/USD 1.1172 / EUR/CAD 1.5606); used only for the season summary purse total.
export const CAD_TO_USD_RATE = 0.71588;
// Season summary totals (purse in USD) of finished seasons, taken from
// /api/season-summary. They never change, so the card skips the fetch for them.
export const PAST_SEASON_SUMMARIES: Record<
  number,
  { purse: number; players: number; tournaments: number }
> = {
  1: { purse: 826400, players: 956, tournaments: 6 },
  2: { purse: 1726800, players: 1575, tournaments: 11 },
  3: { purse: 1073850, players: 1449, tournaments: 8 },
  4: { purse: 1375075, players: 5359, tournaments: 14 },
};
export const INITIAL_PURSE_PGA_AUSTRALIA_S5 = 10000;
export const SPONSOR_PURSE_PGA_AUSTRALIA_S5 = 0;
export const ENTRY_FEE_PGA_AUSTRALIA_S5 = 100;
export const SIDE_GAMES_PGA_AUSTRALIA_S5 = 4200;
export const FIRST_PLACE_PRIZE_PGA_AUSTRALIA_S5 = 5000;
export const MIN_PRIZE_PGA_AUSTRALIA_S5 = 50;
export const PRIZE_SCALING_PGA_AUSTRALIA_S5 = 0.22;
export const INITIAL_PURSE_PGA_CANADA_S5 = 10000;
export const SPONSOR_PURSE_PGA_CANADA_S5 = 0;
export const ENTRY_FEE_PGA_CANADA_S5 = 100;
export const SIDE_GAMES_PGA_CANADA_S5 = 4200;
export const FIRST_PLACE_PRIZE_PGA_CANADA_S5 = 7500;
export const MIN_PRIZE_PGA_CANADA_S5 = 50;
export const PRIZE_SCALING_PGA_CANADA_S5 = 0.25;
export const INITIAL_PURSE_EPSON_S5 = 40000;
export const SPONSOR_PURSE_EPSON_S5 = 0;
export const ENTRY_FEE_EPSON_S5 = 50;
export const SIDE_GAMES_EPSON_S5 = 8500;
export const FIRST_PLACE_PRIZE_EPSON_S5 = 10000;
export const MIN_PRIZE_EPSON_S5 = 50;
export const PRIZE_SCALING_EPSON_S5 = 0.15;

// Season 5 side-card prize lists for PurseSeason5.tsx — same placeholder
// caveat as above.
export const AGGREGATE_CTP_S5 = ["1,500", "500"];
export const LONGEST_DRIVE_MEN_S5 = ["1,500", "1,000", "500"];
export const LONGEST_DRIVE_WOMEN_S5 = ["1,500", "1,000", "500"];
export const CTP_S5 = ["1,000", "750", "500"];
export const CTP_WORLD_SERIES_S5 = ["1,250", "1,000", "750"];
export const CTP_CHAMPIONSHIP_S5 = ["2,000", "1,000", "750"];
export const LONGEST_DRIVE_WOMEN_CHAMPIONSHIP_S5 = ["1,500", "1,000", "750"];
export const CTP_EPSON_S5 = ["1,000", "500", "250"];
export const LONGEST_DRIVE_EPSON_S5 = ["1,000", "500"];
export const CTP_PGA_S5 = ["750", "500", "300", "200"];
export const LONGEST_DRIVE_PGA_S5 = ["750"];
export const CTP_PGA_AUSTRALIA_S5 = ["400", "300", "200"];
export const LONGEST_DRIVE_PGA_AUSTRALIA_S5 = ["300"];
export const CTP_PGA_CANADA_S5 = ["400", "300", "200"];
export const LONGEST_DRIVE_PGA_CANADA_S5 = ["300"];

export const TOURNAMENT_ID_SEASON_1_FINAL =
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZGJlYWFhMDhmLTQ4ZGMtNDY2ZC05MDEwLTBlMTliOWRkMjg1YjpQdWJsaXNoZWQ=";
export const TOURNAMENT_IDS_SEASON_1 = [
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZDJiMTlmNWYxLWExMTUtNDQ5Ny1hZTk0LWI5YWY2NTA4OTBkNzpQdWJsaXNoZWQ=",
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZGExMzU4YWE3LTE1YmYtNDlkZC04NDlkLWM0YzQ0Njc4M2Y0MTpQdWJsaXNoZWQ=",
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZGNiMmQ5MTgwLWNlOWItNDYyYi1hNWU3LTI0ZjhlMTRmMWJjNTpQdWJsaXNoZWQ=",
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZGZjNjY4ZmMxLWU2YjMtNDFhNC1iNGY5LWM3ODlmMmFlMzRmZTpQdWJsaXNoZWQ=",
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZDE0ZjQ1NWY0LThjMjgtNGFmMy05MDYzLWQ1ZmYzYjA1YzQ4MzpQdWJsaXNoZWQ=",
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZGJlYWFhMDhmLTQ4ZGMtNDY2ZC05MDEwLTBlMTliOWRkMjg1YjpQdWJsaXNoZWQ=",
];

export const PGA_TOURNAMENT_ID_SEASON_3 =
  "TXVsdGlSb3VuZFRvdXJuYW1lbnQKZDlmMDQzOGQ0LWFjMWEtNDJlZS1hNTdjLWJhNTFlNWFkZGY5MjpQdWJsaXNoZWQ=";

export const NEXT_PUBLIC_YOUTUBE_API_KEY =
  "AIzaSyBQofqnLwyQvsgdkxjSzbb7AaC6cZnUqAw";

export const NEWS_PER_PAGE = 13;
